
export default {
    state:{
		token:"", // token
	},
    mutations:{
		setTokenKey(state, data){
            console.log(data,"我拿到了");
            state.token = data;
        },
	},
    actions: {
        setTokenKey({ commit },data) {
            commit('setTokenKey',data);
        },
        
    }
}